import $ from "jquery";

import AutoNumeric from "autonumeric";

import "slick-slider/slick/slick.min.js";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import moment from "moment";
window.moment = moment;

// require("apexcharts");
// import ApexCharts from "apexcharts";

// import jscolor
import jscolor from "@eastdesire/jscolor";

jscolor.presets.default = {
    previewSize: 50,
    padding: 20,
};

try {
    window.$ = window.jQuery = require("jquery");
} catch (e) {}

require("select2");

// import Echo from "laravel-echo";

// window.Pusher = require("pusher-js");

// window.Echo = new Echo({
//     broadcaster: "pusher",
//     key: "career_lane_sockets",
//     wsHost: window.location.hostname,
//     wsPort: 6001,
//     forceTLS: false,
//     disableStats: true,
//     cluster: "mt1",
// });

// const button = document.getElementById("edit");
// const display = document.getElementById("display");
// const input = document.getElementById("input");
// input.value = display.innerHTML;
// const displayClass = display.classList;
// const inputClass = input.classList;
// const editIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
//                                         <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"></path>
//                                         <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"></path>
//                                     </svg>`;
// const saveIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
//   <path stroke-linecap="round" stroke-linejoin="round" d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z" />
// </svg>
// `

// button.addEventListener("click", (event) => {
//     if (event.target.getAttribute("data-action") === "edit") {
//         event.target.setAttribute("data-action", "save");
//         // event.target.innerHTML = saveIcon
//         inputClass.remove("hidden");
//         displayClass.add("hidden");

//         return;
//     }
//     event.target.setAttribute("data-action", "edit");
//     inputClass.add("hidden");
//     display.innerHTML = input.value;
//     displayClass.remove("hidden");

//     // event.target.innerHTML = editIcon
// });

import Datepicker from "vanillajs-datepicker/Datepicker";

// find all input fields with an attribute of datepicker
handleDatePickers();

function handleDatePickers() {
    setTimeout(() => {
        const datepickerInputs = document.querySelectorAll("[datepicker]");

        // loop over each input and create a new Datepicker
        datepickerInputs.forEach((input) => {
            // if the input is not visible, don't create a datepicker
            if (
                !input.offsetWidth &&
                !input.offsetHeight &&
                !input.getClientRects().length
            ) {
                return;
            }

            new Datepicker(input, {
                format: "dd/mm/yyyy",
                autohide: true,
                showOnFocus: false,
                todayHighlight: false,
            });

            // when datePick changes, update the input value
            input.addEventListener("changeDate", function (e) {
                if (e.detail.date !== undefined) {
                    input.setAttribute(
                        "data-value",
                        moment(e.detail.date).format("YYYY-MM-DD")
                    );
                } else {
                    input.removeAttribute("data-value");
                }

                // trigger change event
                input.dispatchEvent(new Event("input"));
            });
        });
    }, 250);
}

// listen for browser event
document.addEventListener("loadDatePickers", handleDatePickers);

// hack for input fields without a required attribute
// window.addEventListener("load", handleInputs);
// window.addEventListener("livewire:init", handleInputs);

// function handleInputs() {
//     var inp = document.querySelectorAll("input");

//     for (var i = 0; i < inp.length; i++) {
//         // if inp[1] is a radio button, skip
//         if (inp[i].type === "radio") {
//             continue;
//         }

//         inp[i].addEventListener("change", function () {
//             if (this.value) {
//                 this.setAttribute("data-value", this.value);
//             } else {
//                 this.removeAttribute("data-value");
//             }
//         });

//         // if it has a value onload, set it to data-value
//         if (inp[i].value) {
//             inp[i].setAttribute("data-value", inp[i].value);
//         }
//     }
// }

// Select2
$(".select2").select2({
    width: "100%",
});

// slick slider js

$(".job-card-related").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                arrows: false,
            },
        },
    ],
});

// step from

$("#continue").click(function () {
    const progress = +$(".dots").css("--progress").slice(0, -1);

    if (progress > 10) {
        $("span.active:last").next("span").addClass("active");
        if (progress === 30) $(".dots").css("--progress", 0 + "%");
        else $(".dots").css("--progress", progress - 20 + "%");
    }
});

$("#prev").click(function () {
    const progress = +$(".dots").css("--progress").slice(0, -1);

    if (progress < 90) {
        if (progress === 0) $(".dots").css("--progress", 30 + "%");
        else $(".dots").css("--progress", progress + 20 + "%");
        $("span.active:last").removeClass("active");
    }
});

var ratings = {
    careerDevelopment: 0,
    workLifeBalance: 0,
    cultureAndValues: 0,
    management: 0,
    benefitsAndPerks: 0,
    overallRating: 0,
};

$(".star").hover(
    function () {
        $(this).prevAll().addClass("hover");
        $(this).addClass("hover");
    },
    function () {
        var ratingName = $(this).data("name");
        var rating = ratings[ratingName];

        // loop through previous elements and remove hover class if the data rating is higher than whats set
        $(this)
            .prevAll()
            .each(function () {
                if (!rating || $(this).data("rating") > rating) {
                    $(this).removeClass("hover");
                }
            });

        // remove hover class if the data rating is higher than whats set
        if (!rating || $(this).data("rating") > rating) {
            $(this).removeClass("hover");
        }
    }
);

// on click of star, set the rating so we don't ever remove this hover
$(".star").click(function () {
    var ratingName = $(this).data("name");
    ratings[ratingName] = $(this).data("rating");
});

["experience", "pros", "cons", "advice"].forEach(function (id) {
    if ($("#" + id).length) {
        var minLength = 50;

        $("#" + id + "-character-count").hide();

        $("#" + id).keyup(function () {
            var length = $(this).val().length;
            var length = minLength - length;

            if (length <= 0) {
                $("#" + id + "-character-count").hide();
            } else {
                $("#" + id + "-character-count").show();
            }

            $("#" + id + "-character-count #char-count").text(length);
        });
    }
});

// Company Dashboard Chart
// var optionsBar = {
//     chart: {
//         type: "bar",
//         height: 260,
//         width: "100%",
//         stacked: true,
//     },
//     plotOptions: {
//         bar: {
//             columnWidth: "45%",
//         },
//     },
//     colors: ["#4b5563", "#1e293b"],
//     // colors: colorPalette,
//     series: [
//         {
//             name: "Job Applied",
//             data: [42, 52, 16, 55, 59, 51, 45, 32, 26, 33, 44, 51, 42, 56],
//             // colors: '#9C27B0',
//         },
//         {
//             name: "Job Views",
//             data: [6, 12, 4, 7, 5, 3, 6, 4, 3, 3, 5, 6, 7, 4],
//             // colors: '#9C52B0',
//         },
//     ],
//     labels: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
//     xaxis: {
//         labels: {
//             show: false,
//         },
//         axisBorder: {
//             show: false,
//         },
//         axisTicks: {
//             show: false,
//         },
//     },
//     yaxis: {
//         axisBorder: {
//             show: false,
//         },
//         axisTicks: {
//             show: false,
//         },
//         labels: {
//             style: {
//                 colors: "#78909c",
//             },
//         },
//     },
//     fill: {
//         colors: ["#4b5563", "#1e293b"],
//     },
//     title: {
//         text: "",
//         align: "left",
//         style: {
//             fontSize: "18px",
//         },
//     },
// };

// if (document.querySelector("#bar")) {
//     var chartBar = new ApexCharts(document.querySelector("#bar"), optionsBar);
//     chartBar.render();
// }

$(document).on("click", ".scroll-to-top", function (e) {
    window.scrollTo({ top: 0, behavior: "instant" });
    return false;
});

// if from-range on page
if ($("#from-range").length) {
    var fromRange = new AutoNumeric("#from-range", {
        allowDecimalPadding: false,
    });
}
if ($("#to-range").length) {
    var toRange = new AutoNumeric("#to-range", {
        allowDecimalPadding: false,
    });
}

document.addEventListener("livewire:init", () => {
    let openAlert = null;

    Livewire.on("alert", (options) => {
        const debug = false;

        let { type, title, body, confirm, component } = options[0];

        if (confirm) {
            type = "confirm";
        }

        const alertDiv = document.getElementById(type + "Div");
        const alertWrapper = document.getElementById("alertWrapper");

        if (alertDiv) {
            // copy this element
            var newAlert = alertDiv.cloneNode(true);

            // set the title and body
            newAlert.querySelector(".title").innerHTML = title;

            if (body) {
                newAlert.querySelector(".body").innerHTML = body;
            }

            if (confirm === true) {
                if (component.id && component.listener) {
                    // listen for click even on the confirm button
                    newAlert
                        .querySelector(".confirm")
                        .addEventListener("click", () => {
                            // emit the confirm event to the server
                            Livewire.find(component.id).emitSelf(
                                component.listener,
                                ...component.parameters
                            );
                            closeAlert(newAlert);
                        });
                }
            }

            // add event listener to all of the close buttons
            newAlert.querySelectorAll(".close").forEach((close) => {
                close.addEventListener("click", () => {
                    closeAlert(newAlert);
                });
            });

            if (openAlert) {
                forceCloseAlert(openAlert);
            }

            // insert it into the parent
            alertWrapper.appendChild(newAlert);

            // show the alert
            newAlert.classList.add("show");

            // set the id
            let dashTitle = title.replace(/\s+/g, "-").toLowerCase();
            newAlert.id = dashTitle + "-alert";

            // show the parent
            alertWrapper.classList.add("show");

            if (!confirm) {
                // start the progress bar
                newAlert.querySelector(".progress-bar").classList.add("start");
            }

            openAlert = newAlert;

            if (!confirm && !debug) {
                setTimeout(function () {
                    closeAlert(newAlert);
                }, 3000);
            }
        }
    });

    function closeAlert(alertDiv) {
        // hide the alert
        alertDiv.classList.add("hide");

        alertDiv.addEventListener("animationend", function () {
            alertDiv.remove();
            openAlert = null;
        });
    }

    function forceCloseAlert(alertDiv) {
        alertDiv.remove();
    }
});

// Fancybox
Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

$(".testimonial-slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
});
